import React from 'react';
import { IonButton } from '@ionic/react';
import '@/components/Interstitial.css';

interface WelcomeButtonProps {
  onClick: () => void;
  /** Defaults to "Continue", which dismisses into the topic. */
  label?: string;
  fill?: 'clear' | 'outline' | 'solid';
  disabled?: boolean;
  testId?: string;
}

/**
 * A full-width action button in a welcome sheet. Every type ends its
 * above-the-fold content with one that dismisses into the topic; a type with a
 * second action (news passing a run on) stacks another above it.
 */
const WelcomeButton: React.FC<WelcomeButtonProps> = ({
  onClick,
  label = 'Continue',
  fill,
  disabled = false,
  testId,
}) => (
  <IonButton
    expand="block"
    fill={fill}
    disabled={disabled}
    className="interstitial__continue-btn"
    onClick={onClick}
    data-testid={testId}
  >
    {label}
  </IonButton>
);

export default WelcomeButton;
